module.exports = __webpack_public_path__ + "static/lastcargo-1b3243c59ec8c455728df9855a9ae903.png";